import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { Role } from '../api/types';
import { useT } from '../i18n';
import { useAuth } from '../providers/AuthProvider';

interface Props {
  children: ReactNode;
  /** Omit to allow any signed-in user. */
  roles?: Role[];
}

/**
 * Route guard. This is UX, not security — every protected endpoint is also
 * enforced server-side by requireAuth/requireRole.
 */
export function RequireAuth({ children, roles }: Props) {
  const { t } = useT();
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <p className="muted">{t('loading')}</p>;
  // The query string travels too: a booking page carries the chosen slot in it.
  if (!user) return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;

  return <>{children}</>;
}
